import { AppLanguage } from './types';

type Dict = Record<string, string>;

const sr: Dict = {
  'nav.stanjeRobe': 'Stanje robe',
  'nav.isporuke': 'Isporuke',
  'nav.trenutnoStanje': 'Trenutno stanje',
  'layout.logout': 'Odjavi se',
  'layout.notifications': 'Notifikacije',
  'layout.reportItIssue': 'Prijavi IT problem',
  'layout.roleCustomer': 'Kupac',
  'status.title': 'Trenutno stanje robe',
  'status.subtitleWithBrand': 'Prikazano stanje za brend(ove): {brand}',
  'status.subtitleNoBrand': 'Niste povezani sa brendom — kontaktirajte supplier-a.',
  'status.refresh': 'Osveži',
  'status.empty': 'Nema podataka o stanju.',
  'status.product': 'Roba',
  'status.brand': 'Brend',
  'status.currentKom': 'Trenutno (kom)',
  'status.currentPaleta': 'Trenutno (paleta)',
  'status.currentM2': 'Trenutno (m²)',
  'unit.kom': 'kom',
  'unit.paleta': 'paleta',
  'unit.m2': 'm²',
  'shipments.title': 'Isporuke',
  'shipments.subtitle': 'Pregled robe koja vam je poslata',
  'shipments.refresh': 'Osveži',
  'shipments.empty': 'Nema zabeleženih isporuka',
  'shipments.date': 'Datum',
  'shipments.itemCount': 'Broj stavki',
  'shipments.totalM2': 'Ukupno m²',
  'shipments.actions': 'Akcije',
  'shipments.detailTitle': 'Isporuka – {date}',
  'shipments.detailTitleFallback': 'Isporuka',
  'shipments.close': 'Zatvori',
  'shipments.note': 'Napomena',
  'shipments.items': 'Stavke',
  'shipments.product': 'Roba',
  'shipments.pallet': 'Paleta',
  'shipments.m2': 'm²',
  'shipments.noItems': 'Nema stavki',
  'errors.loadStatus': 'Greška pri učitavanju stanja',
  'errors.loadShipments': 'Greška pri učitavanju isporuka',
  'notifications.title': 'Notifikacije',
  'notifications.search': 'Pretraga...',
  'notifications.searchDesktop': 'Filtriraj notifikacije...',
  'notifications.emptyTitle': 'Nema notifikacija',
  'notifications.emptySub': 'Kada se nešto dogodi, javićemo vam ovde.',
  'notifications.loading': 'Učitavanje...',
  'notifications.markAllRead': 'Označi sve kao pročitane',
  'notifications.markAllReadShort': 'Označi sve kao pročitano',
  'notifications.deleteAll': 'Obriši sve',
  'notifications.confirmDeleteAll': 'Da li ste sigurni da želite da obrišete sve notifikacije?',
  'notifications.confirmDeleteTitle': 'Potvrda brisanja',
  'notifications.typeShipment': 'Isporuka robe',
  'notifications.markRead': 'Označi kao pročitano',
  'notifications.delete': 'Obriši',
  'notifications.view': 'Pogledaj',
  'notifications.columnType': 'Tip',
  'notifications.columnMessage': 'Poruka',
  'notifications.columnDate': 'Datum i vreme',
  'notifications.columnActions': 'Akcije',
  'notifications.emptyTable': 'Nema notifikacija',
  'notifications.system': 'Sistem',
  'notifications.desktopTitle': 'Nova notifikacija',
  'notifications.desktopBody': 'Imate nove notifikacije.',
  'notify.single': 'Poslata vam je roba: {product} — {quantity} {unit} ({m2} m²)',
  'notify.batch': 'Nova isporuka ({date}): {lines} Ukupno: {total} m²',
  'time.justNow': 'Upravo sada',
  'time.minutesAgo': 'Pre {count} min',
  'time.hoursAgo': 'Pre {count} h',
  'time.yesterday': 'Juče',
  'time.daysAgo': 'Pre {count} dana',
  'time.weeksAgo': 'Pre {count} ned.'
};

const en: Dict = {
  'nav.stanjeRobe': 'Stock status',
  'nav.isporuke': 'Shipments',
  'nav.trenutnoStanje': 'Current stock',
  'layout.logout': 'Log out',
  'layout.notifications': 'Notifications',
  'layout.reportItIssue': 'Report IT issue',
  'layout.roleCustomer': 'Customer',
  'status.title': 'Current stock',
  'status.subtitleWithBrand': 'Stock for brand: {brand}',
  'status.subtitleNoBrand': 'You are not linked to a brand — contact your supplier.',
  'status.refresh': 'Refresh',
  'status.empty': 'No stock data.',
  'status.product': 'Product',
  'status.brand': 'Brand',
  'status.currentKom': 'Current (pcs)',
  'status.currentPaleta': 'Current (pallets)',
  'status.currentM2': 'Current (m²)',
  'unit.kom': 'pcs',
  'unit.paleta': 'pallets',
  'unit.m2': 'm²',
  'shipments.title': 'Shipments',
  'shipments.subtitle': 'Overview of goods sent to you',
  'shipments.refresh': 'Refresh',
  'shipments.empty': 'No shipments recorded',
  'shipments.date': 'Date',
  'shipments.itemCount': 'Line items',
  'shipments.totalM2': 'Total m²',
  'shipments.actions': 'Actions',
  'shipments.detailTitle': 'Shipment – {date}',
  'shipments.detailTitleFallback': 'Shipment',
  'shipments.close': 'Close',
  'shipments.note': 'Note',
  'shipments.items': 'Items',
  'shipments.product': 'Product',
  'shipments.pallet': 'Pallet',
  'shipments.m2': 'm²',
  'shipments.noItems': 'No items',
  'errors.loadStatus': 'Failed to load stock',
  'errors.loadShipments': 'Failed to load shipments',
  'notifications.title': 'Notifications',
  'notifications.search': 'Search...',
  'notifications.searchDesktop': 'Filter notifications...',
  'notifications.emptyTitle': 'No notifications',
  'notifications.emptySub': 'When something happens, we will notify you here.',
  'notifications.loading': 'Loading...',
  'notifications.markAllRead': 'Mark all as read',
  'notifications.markAllReadShort': 'Mark all as read',
  'notifications.deleteAll': 'Delete all',
  'notifications.confirmDeleteAll': 'Are you sure you want to delete all notifications?',
  'notifications.confirmDeleteTitle': 'Confirm deletion',
  'notifications.typeShipment': 'Goods shipment',
  'notifications.markRead': 'Mark as read',
  'notifications.delete': 'Delete',
  'notifications.view': 'View',
  'notifications.columnType': 'Type',
  'notifications.columnMessage': 'Message',
  'notifications.columnDate': 'Date and time',
  'notifications.columnActions': 'Actions',
  'notifications.emptyTable': 'No notifications',
  'notifications.system': 'System',
  'notifications.desktopTitle': 'New notification',
  'notifications.desktopBody': 'You have new notifications.',
  'notify.single': 'Goods shipped to you: {product} — {quantity} {unit} ({m2} m²)',
  'notify.batch': 'New shipment ({date}): {lines} Total: {total} m²',
  'time.justNow': 'Just now',
  'time.minutesAgo': '{count} min ago',
  'time.hoursAgo': '{count} h ago',
  'time.yesterday': 'Yesterday',
  'time.daysAgo': '{count} days ago',
  'time.weeksAgo': '{count} wk ago'
};

const de: Dict = {
  'nav.stanjeRobe': 'Lagerbestand',
  'nav.isporuke': 'Lieferungen',
  'nav.trenutnoStanje': 'Aktueller Bestand',
  'layout.logout': 'Abmelden',
  'layout.notifications': 'Benachrichtigungen',
  'layout.reportItIssue': 'IT-Problem melden',
  'layout.roleCustomer': 'Kunde',
  'status.title': 'Aktueller Lagerbestand',
  'status.subtitleWithBrand': 'Bestand für Marke: {brand}',
  'status.subtitleNoBrand': 'Sie sind keiner Marke zugeordnet — kontaktieren Sie Ihren Lieferanten.',
  'status.refresh': 'Aktualisieren',
  'status.empty': 'Keine Bestandsdaten.',
  'status.product': 'Ware',
  'status.brand': 'Marke',
  'status.currentKom': 'Aktuell (Stk)',
  'status.currentPaleta': 'Aktuell (Paletten)',
  'status.currentM2': 'Aktuell (m²)',
  'unit.kom': 'Stk',
  'unit.paleta': 'Paletten',
  'unit.m2': 'm²',
  'shipments.title': 'Lieferungen',
  'shipments.subtitle': 'Übersicht der an Sie gesendeten Waren',
  'shipments.refresh': 'Aktualisieren',
  'shipments.empty': 'Keine Lieferungen erfasst',
  'shipments.date': 'Datum',
  'shipments.itemCount': 'Positionen',
  'shipments.totalM2': 'Gesamt m²',
  'shipments.actions': 'Aktionen',
  'shipments.detailTitle': 'Lieferung – {date}',
  'shipments.detailTitleFallback': 'Lieferung',
  'shipments.close': 'Schließen',
  'shipments.note': 'Anmerkung',
  'shipments.items': 'Positionen',
  'shipments.product': 'Ware',
  'shipments.pallet': 'Palette',
  'shipments.m2': 'm²',
  'shipments.noItems': 'Keine Positionen',
  'errors.loadStatus': 'Fehler beim Laden des Bestands',
  'errors.loadShipments': 'Fehler beim Laden der Lieferungen',
  'notifications.title': 'Benachrichtigungen',
  'notifications.search': 'Suchen...',
  'notifications.searchDesktop': 'Benachrichtigungen filtern...',
  'notifications.emptyTitle': 'Keine Benachrichtigungen',
  'notifications.emptySub': 'Wenn etwas passiert, informieren wir Sie hier.',
  'notifications.loading': 'Laden...',
  'notifications.markAllRead': 'Alle als gelesen markieren',
  'notifications.markAllReadShort': 'Alle als gelesen markieren',
  'notifications.deleteAll': 'Alle löschen',
  'notifications.confirmDeleteAll': 'Möchten Sie wirklich alle Benachrichtigungen löschen?',
  'notifications.confirmDeleteTitle': 'Löschen bestätigen',
  'notifications.typeShipment': 'Warenlieferung',
  'notifications.markRead': 'Als gelesen markieren',
  'notifications.delete': 'Löschen',
  'notifications.view': 'Ansehen',
  'notifications.columnType': 'Typ',
  'notifications.columnMessage': 'Nachricht',
  'notifications.columnDate': 'Datum und Uhrzeit',
  'notifications.columnActions': 'Aktionen',
  'notifications.emptyTable': 'Keine Benachrichtigungen',
  'notifications.system': 'System',
  'notifications.desktopTitle': 'Neue Benachrichtigung',
  'notifications.desktopBody': 'Sie haben neue Benachrichtigungen.',
  'notify.single': 'Ware wurde an Sie gesendet: {product} — {quantity} {unit} ({m2} m²)',
  'notify.batch': 'Neue Lieferung ({date}): {lines} Gesamt: {total} m²',
  'time.justNow': 'Gerade eben',
  'time.minutesAgo': 'Vor {count} Min.',
  'time.hoursAgo': 'Vor {count} Std.',
  'time.yesterday': 'Gestern',
  'time.daysAgo': 'Vor {count} Tagen',
  'time.weeksAgo': 'Vor {count} Wo.'
};

const pl: Dict = {
  'nav.stanjeRobe': 'Stan magazynowy',
  'nav.isporuke': 'Dostawy',
  'nav.trenutnoStanje': 'Aktualny stan',
  'layout.logout': 'Wyloguj',
  'layout.notifications': 'Powiadomienia',
  'layout.reportItIssue': 'Zgłoś problem IT',
  'layout.roleCustomer': 'Klient',
  'status.title': 'Aktualny stan towaru',
  'status.subtitleWithBrand': 'Stan dla marki: {brand}',
  'status.subtitleNoBrand': 'Nie jesteś powiązany z marką — skontaktuj się z dostawcą.',
  'status.refresh': 'Odśwież',
  'status.empty': 'Brak danych o stanie.',
  'status.product': 'Towar',
  'status.brand': 'Marka',
  'status.currentKom': 'Aktualnie (szt)',
  'status.currentPaleta': 'Aktualnie (palety)',
  'status.currentM2': 'Aktualnie (m²)',
  'unit.kom': 'szt',
  'unit.paleta': 'palety',
  'unit.m2': 'm²',
  'shipments.title': 'Dostawy',
  'shipments.subtitle': 'Przegląd towarów wysłanych do Ciebie',
  'shipments.refresh': 'Odśwież',
  'shipments.empty': 'Brak zarejestrowanych dostaw',
  'shipments.date': 'Data',
  'shipments.itemCount': 'Liczba pozycji',
  'shipments.totalM2': 'Razem m²',
  'shipments.actions': 'Akcje',
  'shipments.detailTitle': 'Dostawa – {date}',
  'shipments.detailTitleFallback': 'Dostawa',
  'shipments.close': 'Zamknij',
  'shipments.note': 'Uwaga',
  'shipments.items': 'Pozycje',
  'shipments.product': 'Towar',
  'shipments.pallet': 'Paleta',
  'shipments.m2': 'm²',
  'shipments.noItems': 'Brak pozycji',
  'errors.loadStatus': 'Błąd ładowania stanu',
  'errors.loadShipments': 'Błąd ładowania dostaw',
  'notifications.title': 'Powiadomienia',
  'notifications.search': 'Szukaj...',
  'notifications.searchDesktop': 'Filtruj powiadomienia...',
  'notifications.emptyTitle': 'Brak powiadomień',
  'notifications.emptySub': 'Gdy coś się wydarzy, powiadomimy Cię tutaj.',
  'notifications.loading': 'Ładowanie...',
  'notifications.markAllRead': 'Oznacz wszystkie jako przeczytane',
  'notifications.markAllReadShort': 'Oznacz wszystkie jako przeczytane',
  'notifications.deleteAll': 'Usuń wszystkie',
  'notifications.confirmDeleteAll': 'Czy na pewno chcesz usunąć wszystkie powiadomienia?',
  'notifications.confirmDeleteTitle': 'Potwierdzenie usunięcia',
  'notifications.typeShipment': 'Dostawa towaru',
  'notifications.markRead': 'Oznacz jako przeczytane',
  'notifications.delete': 'Usuń',
  'notifications.view': 'Zobacz',
  'notifications.columnType': 'Typ',
  'notifications.columnMessage': 'Wiadomość',
  'notifications.columnDate': 'Data i godzina',
  'notifications.columnActions': 'Akcje',
  'notifications.emptyTable': 'Brak powiadomień',
  'notifications.system': 'System',
  'notifications.desktopTitle': 'Nowe powiadomienie',
  'notifications.desktopBody': 'Masz nowe powiadomienia.',
  'notify.single': 'Wysłano do Ciebie towar: {product} — {quantity} {unit} ({m2} m²)',
  'notify.batch': 'Nowa dostawa ({date}): {lines} Razem: {total} m²',
  'time.justNow': 'Przed chwilą',
  'time.minutesAgo': '{count} min temu',
  'time.hoursAgo': '{count} godz. temu',
  'time.yesterday': 'Wczoraj',
  'time.daysAgo': '{count} dni temu',
  'time.weeksAgo': '{count} tyg. temu'
};

const cs: Dict = {
  'nav.stanjeRobe': 'Stav zásob',
  'nav.isporuke': 'Dodávky',
  'nav.trenutnoStanje': 'Aktuální stav',
  'layout.logout': 'Odhlásit se',
  'layout.notifications': 'Oznámení',
  'layout.reportItIssue': 'Nahlásit IT problém',
  'layout.roleCustomer': 'Zákazník',
  'status.title': 'Aktuální stav zboží',
  'status.subtitleWithBrand': 'Stav pro značku: {brand}',
  'status.subtitleNoBrand': 'Nejste propojeni se značkou — kontaktujte dodavatele.',
  'status.refresh': 'Obnovit',
  'status.empty': 'Žádná data o stavu.',
  'status.product': 'Zboží',
  'status.brand': 'Značka',
  'status.currentKom': 'Aktuálně (ks)',
  'status.currentPaleta': 'Aktuálně (palety)',
  'status.currentM2': 'Aktuálně (m²)',
  'unit.kom': 'ks',
  'unit.paleta': 'palety',
  'unit.m2': 'm²',
  'shipments.title': 'Dodávky',
  'shipments.subtitle': 'Přehled zboží odeslaného vám',
  'shipments.refresh': 'Obnovit',
  'shipments.empty': 'Žádné zaznamenané dodávky',
  'shipments.date': 'Datum',
  'shipments.itemCount': 'Počet položek',
  'shipments.totalM2': 'Celkem m²',
  'shipments.actions': 'Akce',
  'shipments.detailTitle': 'Dodávka – {date}',
  'shipments.detailTitleFallback': 'Dodávka',
  'shipments.close': 'Zavřít',
  'shipments.note': 'Poznámka',
  'shipments.items': 'Položky',
  'shipments.product': 'Zboží',
  'shipments.pallet': 'Paleta',
  'shipments.m2': 'm²',
  'shipments.noItems': 'Žádné položky',
  'errors.loadStatus': 'Chyba při načítání stavu',
  'errors.loadShipments': 'Chyba při načítání dodávek',
  'notifications.title': 'Oznámení',
  'notifications.search': 'Hledat...',
  'notifications.searchDesktop': 'Filtrovat oznámení...',
  'notifications.emptyTitle': 'Žádná oznámení',
  'notifications.emptySub': 'Až se něco stane, dáme vám vědět zde.',
  'notifications.loading': 'Načítání...',
  'notifications.markAllRead': 'Označit vše jako přečtené',
  'notifications.markAllReadShort': 'Označit vše jako přečtené',
  'notifications.deleteAll': 'Smazat vše',
  'notifications.confirmDeleteAll': 'Opravdu chcete smazat všechna oznámení?',
  'notifications.confirmDeleteTitle': 'Potvrzení smazání',
  'notifications.typeShipment': 'Dodávka zboží',
  'notifications.markRead': 'Označit jako přečtené',
  'notifications.delete': 'Smazat',
  'notifications.view': 'Zobrazit',
  'notifications.columnType': 'Typ',
  'notifications.columnMessage': 'Zpráva',
  'notifications.columnDate': 'Datum a čas',
  'notifications.columnActions': 'Akce',
  'notifications.emptyTable': 'Žádná oznámení',
  'notifications.system': 'Systém',
  'notifications.desktopTitle': 'Nové oznámení',
  'notifications.desktopBody': 'Máte nová oznámení.',
  'notify.single': 'Bylo vám odesláno zboží: {product} — {quantity} {unit} ({m2} m²)',
  'notify.batch': 'Nová dodávka ({date}): {lines} Celkem: {total} m²',
  'time.justNow': 'Právě teď',
  'time.minutesAgo': 'Před {count} min',
  'time.hoursAgo': 'Před {count} h',
  'time.yesterday': 'Včera',
  'time.daysAgo': 'Před {count} dny',
  'time.weeksAgo': 'Před {count} týd.'
};

const fr: Dict = {
  'nav.stanjeRobe': 'État des stocks',
  'nav.isporuke': 'Expéditions',
  'nav.trenutnoStanje': 'Stock actuel',
  'layout.logout': 'Se déconnecter',
  'layout.notifications': 'Notifications',
  'layout.reportItIssue': 'Signaler un problème IT',
  'layout.roleCustomer': 'Client',
  'status.title': 'Stock actuel',
  'status.subtitleWithBrand': 'Stock pour la marque : {brand}',
  'status.subtitleNoBrand': 'Vous n’êtes pas lié à une marque — contactez votre fournisseur.',
  'status.refresh': 'Actualiser',
  'status.empty': 'Aucune donnée de stock.',
  'status.product': 'Produit',
  'status.brand': 'Marque',
  'status.currentKom': 'Actuel (pcs)',
  'status.currentPaleta': 'Actuel (palettes)',
  'status.currentM2': 'Actuel (m²)',
  'unit.kom': 'pcs',
  'unit.paleta': 'palettes',
  'unit.m2': 'm²',
  'shipments.title': 'Expéditions',
  'shipments.subtitle': 'Aperçu des marchandises qui vous ont été envoyées',
  'shipments.refresh': 'Actualiser',
  'shipments.empty': 'Aucune expédition enregistrée',
  'shipments.date': 'Date',
  'shipments.itemCount': 'Nombre de lignes',
  'shipments.totalM2': 'Total m²',
  'shipments.actions': 'Actions',
  'shipments.detailTitle': 'Expédition – {date}',
  'shipments.detailTitleFallback': 'Expédition',
  'shipments.close': 'Fermer',
  'shipments.note': 'Remarque',
  'shipments.items': 'Lignes',
  'shipments.product': 'Produit',
  'shipments.pallet': 'Palette',
  'shipments.m2': 'm²',
  'shipments.noItems': 'Aucune ligne',
  'errors.loadStatus': 'Erreur lors du chargement du stock',
  'errors.loadShipments': 'Erreur lors du chargement des expéditions',
  'notifications.title': 'Notifications',
  'notifications.search': 'Rechercher...',
  'notifications.searchDesktop': 'Filtrer les notifications...',
  'notifications.emptyTitle': 'Aucune notification',
  'notifications.emptySub': 'Lorsque quelque chose se passe, nous vous préviendrons ici.',
  'notifications.loading': 'Chargement...',
  'notifications.markAllRead': 'Tout marquer comme lu',
  'notifications.markAllReadShort': 'Tout marquer comme lu',
  'notifications.deleteAll': 'Tout supprimer',
  'notifications.confirmDeleteAll': 'Voulez-vous vraiment supprimer toutes les notifications ?',
  'notifications.confirmDeleteTitle': 'Confirmer la suppression',
  'notifications.typeShipment': 'Expédition de marchandises',
  'notifications.markRead': 'Marquer comme lu',
  'notifications.delete': 'Supprimer',
  'notifications.view': 'Voir',
  'notifications.columnType': 'Type',
  'notifications.columnMessage': 'Message',
  'notifications.columnDate': 'Date et heure',
  'notifications.columnActions': 'Actions',
  'notifications.emptyTable': 'Aucune notification',
  'notifications.system': 'Système',
  'notifications.desktopTitle': 'Nouvelle notification',
  'notifications.desktopBody': 'Vous avez de nouvelles notifications.',
  'notify.single': 'Marchandise expédiée : {product} — {quantity} {unit} ({m2} m²)',
  'notify.batch': 'Nouvelle expédition ({date}) : {lines} Total : {total} m²',
  'time.justNow': 'À l’instant',
  'time.minutesAgo': 'Il y a {count} min',
  'time.hoursAgo': 'Il y a {count} h',
  'time.yesterday': 'Hier',
  'time.daysAgo': 'Il y a {count} jours',
  'time.weeksAgo': 'Il y a {count} sem.'
};

const MESSAGES: Record<AppLanguage, Dict> = { sr, en, de, pl, cs, fr };

const NAV_LABEL_KEYS: Record<string, string> = {
  'Stanje robe': 'nav.stanjeRobe',
  'Isporuke': 'nav.isporuke',
  'Trenutno stanje': 'nav.trenutnoStanje'
};

export function translateCustomerPortal(
  lang: AppLanguage,
  key: string,
  params?: Record<string, string>
): string {
  const dict = MESSAGES[lang] || MESSAGES.en;
  let text = dict[key] || MESSAGES.en[key] || MESSAGES.sr[key] || key;
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      text = text.replace(`{${k}}`, v);
    });
  }
  return text;
}

export function translateNavLabel(lang: AppLanguage, label: string): string {
  const key = NAV_LABEL_KEYS[label];
  return key ? translateCustomerPortal(lang, key) : label;
}
